/** Read browser cookies without letting privacy restrictions break application behavior. */
export function readDocumentCookies(): string {
  if (typeof document === "undefined") return "";
  try {
    return document.cookie;
  } catch {
    return "";
  }
}

/** Best-effort cookie write for browser-owned analytics and consent state. */
export function writeDocumentCookie(value: string): boolean {
  if (typeof document === "undefined") return false;
  try {
    document.cookie = value;
    return true;
  } catch {
    return false;
  }
}
